import { Component, OnInit} from '@angular/core'; // Compiler
import NavigationService from '../../services/navigationService';
import Navigation from '../../models/navigation';
import { MessageQueService } from '../../services/index';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  providers: [NavigationService, MessageQueService]
})
export default class NavigationComponent implements OnInit {
  navigation: Navigation;
  cacheControlKey: string;

  constructor(private navigationService: NavigationService, private msgSvc: MessageQueService) { }

  ngOnInit(): void {
    this.msgSvc.setControlKey(); // ('CacheControlKey');

    this.navigationService.getJurisdictions()
      .subscribe((navigation: Navigation) => {
        this.navigation = navigation;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/navigation/navigation.component.ts